import { customFetch } from "@/client/custom-fetch";

import {
  TPlatform,
  TPlatformResponse,
  TReplicatePlatformResponse,
} from "./platform.types";

export const getPlatforms = async (
  organizationId: string,
  projectId?: string
): Promise<TPlatformResponse> => {
  // A API só permite buscar plataformas por projeto ou por ID
  // Se não tiver projectId, retornar array vazio
  if (!projectId) {
    return [];
  }
  
  return customFetch<TPlatformResponse>(`/platforms/project/${projectId}`, {
    method: "GET",
    headers: {
      accept: "application/json",
    },
  });
};

export const getPlatformsByOrganization = async (
  organizationId: string
): Promise<TPlatformResponse> => {
  return customFetch<TPlatformResponse>(
    `/platforms/organization/${organizationId}`,
    {
      method: "GET",
      headers: {
        accept: "application/json",
      },
    }
  );
};

export const replicatePlatformToSubPartners = async (
  platformId: string,
  body: {
    project_id: string;
    sub_partner_ids?: string[];
    all_sub_partners?: boolean;
  }
): Promise<TReplicatePlatformResponse> => {
  return customFetch<TReplicatePlatformResponse>(
    `/platforms/${platformId}/replicate-to-sub-partners`,
    {
      method: "POST",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }
  );
};

export const createPlatform = async (
  organizationId: string,
  formData: FormData
): Promise<TPlatform> => {
  return customFetch<TPlatform>(`/platforms/organization/${organizationId}`, {
    method: "POST",
    body: formData,
    skipLoading: false,
  });
};

export const getPlatformById = async (
  organizationId: string,
  platformId: string
): Promise<TPlatform> => {

  return customFetch<TPlatform>(
    `/platforms/${platformId}`,
    {
      method: "GET",
      headers: {
        accept: "application/json",
      },
    }
  );
};

export const updatePlatform = async (
  organizationId: string,
  platformId: string,
  formData: FormData
): Promise<TPlatform> => {
  return customFetch<TPlatform>(
    `/platforms/${platformId}`,
    {
      method: "PATCH",
      body: formData,
      skipLoading: false,
    }
  );
};

export const deletePlatform = async (
  organizationId: string,
  platformId: string,
  body?: { confirm?: boolean; reason?: string }
): Promise<{ message: string }> => {
  return customFetch<{ message: string }>(
    `/platforms/${platformId}`,
    {
      method: "DELETE",
      headers: {
        accept: "application/json",
        "x-organization-id": organizationId,
      },
      body: body ? JSON.stringify(body) : undefined,
    }
  );
};

export const bulkDeletePlatforms = async (
  organizationId: string,
  platformIds: string[]
): Promise<{ deletedCount: number; notFoundIds: string[] }> => {
  return customFetch<{ deletedCount: number; notFoundIds: string[] }>(
    `/platforms/bulk-delete`,
    {
      method: "POST",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
        "x-organization-id": organizationId,
      },
      body: JSON.stringify({ ids: platformIds }),
    }
  );
};
